import { AllocateServiceDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-service-wizard/allocate-service-init-step/due-dates-step';
import { AllocateServiceInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-service-wizard/allocate-service-init-step/init-step';

export interface State {
  initStep: AllocateServiceInitStepV26;
  dueDatesStep: AllocateServiceDueDatesV26;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null, deactivationDate: null },
};
